import { Box, styled } from '@mui/material';

export const SidebarContainer = styled(Box)`
  & > div:first-child {
    padding: 0 16px;
  }

  padding: 20px 0 0 0;
  height: 100vh;
`;

export const SidebarContent = styled(Box)`
  flex: 1;
  overflow-y: auto;
  height: calc(100vh - 55px);
`;
